<template>
	<div id="news">
		<div class="header">
				  <div class="logo-box">
					  <img class="logo" src="https://cdn.huimiaokeji.com/hjweb/logo.png" @click="navTo('/')"/>
				  </div>
				  <div class="top-menu">
					官方资讯
				  </div>
				  <div class="login-box" @click="goUrl('https://admin.huimiaokeji.com')">
					  <div class="login-btn">
						  登录
					  </div>
				  </div>
		</div>
		<div class="container">
		    <div class="grid-container">
		      <div 
		        v-for="(item, index) in articleList" 
		        :key="index" 
		        class="grid-item"
				@click="goToDetails(item.articleId)"
		      >
		        <!-- 封面图 -->
		              <img 
		                class="cover-image"
		                :src="item.coverImage" 
		                alt="封面图"
		              >
		              <!-- 标题 -->
		              <h3 class="title">{{item.title}}</h3>
		              <!-- 摘要 -->
		              <p class="summary">{{item.summary}}</p>
		      </div>
		    </div>
		  </div>
			<footer-menu></footer-menu>
	</div>
</template>

<script>
	import {getArticleList} from '../api/index.js';
	import FooterMenu from '../components/footer-menu.vue';
	export default {
		name:'News',
		components: {
			FooterMenu
		},
		data() {
			return {
				articleList:[],
				queryParams: {
					pageNum: 1,
					pageSize: 100,
				}
			}
		},
		created() {
		  document.title = '灰鲸网络-官方资讯';
		  this.queryArticleList();
		},
		methods: {
			goToDetails(id) {
			      this.$router.push({ 
			        name: 'newsDetail', 
			        params: { articleId: id }
			      });
			    },
			goUrl(url){
				window.open(url);
			},
			navTo(url) {
				this.$router.push({ path:url})
			},
			async queryArticleList() {
				let res = await getArticleList();
				if (res.code == 200) {
					this.articleList = res.rows || []
				}
			},
		}
	}
</script>

<style lang="less">
	#news {
		background-color: #F3F7FF;
		.header {
			  width: 100%;
			  z-index: 999999;
			  position: fixed;
			  left: 0;
			  top:0 ;
			  display: flex;
			   height: 80px;
			   background-color: #FFFFFF;
			  .logo-box {
				  flex:1;
				  display: flex;
				  align-items: center;
				  .logo {
					margin-left: 40px;
					width: 205px;	
					height: 30px;
					cursor: pointer;
				  }
			  }
			  .top-menu{
				  flex:1;
					  font-size: 20px;
					  font-family: PingFangSC, PingFang SC;
					  font-weight: 400;
					  color: #333333;
					  line-height: 80px;
					  justify-content: space-between;
					  // padding-left: 200px;
					  // padding-right: 200px;
					  text-align: center;
			  }
			  .login-box {
				  flex:1;
				  cursor: pointer;
				  .login-btn {
					  width: 120px;
					  height: 80px;
					  background: #0B00B5;
					  font-family: PingFangSC, PingFang SC;
					  font-weight: bold;
					  font-size: 14px;
					  color: #FFFFFF;
					  line-height: 80px;
					  text-align: center;
					  font-style: normal;
					  float: right;
				  }
			  }
			  margin-bottom: 50px;
		  }
		  
		  /* 新增容器限制最大宽度 */
		  .container {
		    max-width: 1280px; /* 根据设计需求调整 */
		    margin: 0 auto;    /* 居中显示 */
		    padding: 150px 20px 50px 20px;   /* 防止贴边 */
		  }
		  
		  .grid-container {
		    display: grid;
		    grid-template-columns: repeat(3, 1fr);
		    
		    /* 动态间隙：小屏幕20px，大屏幕最大30px */
		    gap: clamp(20px, 2vw, 30px);
		    
		    /* 或者固定间隙（任选其一） */
		    /* gap: 24px; */
		  }
		  
		  .grid-item {
		    /* 限制项目最大宽度（可选） */
		    width: 400px; 
			height: 363px;
		    // width: 100%;
			cursor: pointer;
		    
		    /* 保持项目比例 */
		    aspect-ratio: 1/1;
		    background: #ffffff;
		    border-radius: 12px;
			margin-bottom: 30px;
		    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
		    /* 居中内容 */
		    display: flex;
		    flex-direction: column;
		    // padding: 16px; /* 添加内边距 */
			/* 封面图样式 */
			.cover-image {
			  width: 100%;    /* 继承父容器宽度 */
			  height: 225px;  /* 固定高度 */
			  object-fit: cover; /* 保持图片比例 */
			  border-radius: 12px 12px 0 0; /* 圆角小于父容器 */
			  margin-bottom: 12px; /* 图片和标题间距 */
			}
			
			/* 标题样式 */
			.title {
			  font-size: 20px;
			  color: #333;
			  margin: 0 0 8px 0; /* 下边距8px */
			  
			  /* 单行省略号 */
			  white-space: nowrap;
			  overflow: hidden;
			  text-overflow: ellipsis;
			  padding-top:10px;
			  padding-left: 16px;
			  padding-right: 16px;
			}
			
			/* 摘要样式 */
			.summary {
			  font-size: 14px;
			    color: #666;
			    padding: 0 16px;
			    margin: 0;
			    line-height: 1.5; /* 假设行高是字体大小的1.5倍 */
			    
			    /* 三行省略号核心代码 */
			    display: -webkit-box;
			    -webkit-box-orient: vertical;
			    -webkit-line-clamp: 3; /* 改这里：2→3 */
			    overflow: hidden;
			    
			    /* 精确计算最大高度（3行 x 行高） */
			    max-height: calc(1em * 1.5 * 3); /* 14px * 1.5 * 3 = 63px */
			    
			    /* 跨浏览器兼容方案 */
			    display: -moz-box;
			    -moz-box-orient: vertical;
			    -moz-line-clamp: 3;
			    display: -ms-flexbox;
			    -ms-line-clamp: 3;
			    line-clamp: 3;
			}
		  }
	}
</style>


// WEBPACK FOOTER //
// src/pages/News.vue